<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm">
      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="그룹명">
              <el-input v-model="form.groupNm"></el-input>
              <el-input v-model="form.groupUid" v-show="false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="설명">
              <el-input v-model="form.description"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "groupInfo",
  props: ['groupDetail', 'parentNm'],
  data() {
    return {
      form: {
        groupKey: "",
        groupNm: "",
        groupId: "",
        groupUid: "",
        parentId: "",
        TopKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
        description: "",
      },
    };
  },
  methods: {
    setGroupInfo() {
      Object.assign(this.form, this.groupDetail, this.parentNm);
    },
  },
  watch: {
    groupDetail() {
      this.setGroupInfo();
    }
  }
}

</script>

<style scoped>

</style>